import React from 'react';
import SiteMapComponent from '../../components/siteMap/Component/SiteMapComponent';
import HeaderTags from '../../common/headerTags/HeaderTags';

const headerTags = {
    title: 'Mapa do Site', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Veja tudo sobre os seus artistas e músicas favoritos. Notícias, cultura, promoções e muito mais',
        keywords: 'mapa do site, sitemap, site map',
        'og:title': 'Mapa do Site',
        'og:description': 'Veja tudo sobre os seus artistas e músicas favoritos. Notícias, cultura, promoções e muito mais',
    },
};

const SiteMap = () => (
    <div>
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <div className="pageWrapper">
            <SiteMapComponent />
        </div>
    </div>
);

export default SiteMap;
